import React, { useCallback } from 'react';

import { BankOutlined } from '@ant-design/icons';

import moment from 'moment';

const LoanStatementsRowRow = ({ data, loanId, selectRow }) => {
  const onDetailsClick = useCallback(
    (e) => {
      e.preventDefault();
      selectRow();
      window.scrollTo(0, 0);
    },
    [selectRow]
  );

  return (
    <div className={'row loanPaymentHistoryRow border'}>
      <div>
        <div className="loanPaymentHistoryResult">
          <div className="loanPaymentHistoryBadge paid" />
          <div className="loanPaymentHistoryStatus">Statement Date: </div>
          <div className="loanPaymentHistoryDate">
            {moment(data.statementDate).format('MMMM D, YYYY')}
          </div>
        </div>
        <div className="loanPaymentHistoryBank">
          <BankOutlined />
          {loanId && `Loan: #${loanId}`}
        </div>
      </div>
      <div>
        <div className="loanPaymentHistoryValue">
          <a href="#" onClick={onDetailsClick}>
            Details
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoanStatementsRowRow;
